<template>
  <FAQPage
    v-bind="faqPageProps"
  />
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { GET_REVIEWS } from '@/utils/store/actionTypes'
import { getImagePaths, serializeParameters } from '@/utils/general'
import FAQPage from '@/components/FAQPage'
import customerServiceMixin from '@/mixins/customerService'
import { WomenCountries } from '@/enums/general'

export default {
  name: 'WomenCustomerService',
  layout: 'customer-service',
  components: {
    FAQPage
  },
  mixins: [customerServiceMixin],
  async fetch () {
    await this.loadReviews()
  },
  data () {
    return {
      reviewData: null
    }
  },
  middleware: ({ route, redirect, store: { state: { app: { locale, country } } } }) => {
    const i18Params = `/${locale}-${country}`
    const queryParamsString = serializeParameters(route.query)

    if (!WomenCountries.includes(country)) {
      return redirect(`${i18Params}/men/customer-service?${queryParamsString}`)
    }
  },
  computed: {
    faqPageProps () {
      return {
        blocks: this.blocks,
        locale: this.locale,
        reviewData: this.reviewData,
        isWomen: true
      }
    },
    blocks () {
      return [
        {
          title: this.$t('FAQ.DynamicFaq.Payment'),
          image: getImagePaths({ path: '/images/frontend/faq/payment/image-women', s3: true }),
          questions: [
            this.getWomenQuestionByPath('how-do-i-change-my-payment-details'),
            this.getWomenQuestionByPath('what-does-an-on-that-ass-membership-cost'),
            this.getWomenQuestionByPath('i-have-an-outstanding-payment')
          ]
        },
        {
          title: this.$t('FAQ.DynamicFaq.PauseOrCancel'),
          image: getImagePaths({ path: '/images/frontend/faq/status/image-women', s3: true }),
          questions: [
            this.getWomenQuestionByPath('how-can-i-cancel'),
            this.getWomenQuestionByPath('do-you-have-a-notice-period'),
            this.getWomenQuestionByPath('i-would-like-confirmation-of-my-cancellation')
          ]
        },
        {
          title: this.$t('FAQ.DynamicFaq.Shipment'),
          image: getImagePaths({ path: '/images/frontend/faq/shipment/image-women', s3: true }),
          questions: [
            this.getWomenQuestionByPath('when-will-i-receive-my-monthly-delivery'),
            this.getWomenQuestionByPath('did-not-receive-anything-yet'),
            this.getWomenQuestionByPath('how-do-i-change-my-address-details')
          ]
        }
      ]
    },
    ...mapState('app', {
      locale: state => state.locale
    })
  },
  methods: {
    async loadReviews () {
      try {
        const { data: { reviewSite } } = await this.getReviews()

        const reviewData = {
          name: reviewSite.altText,
          rating: reviewSite.rating,
          maxRating: reviewSite.maxRating,
          amountReviews: reviewSite.amountReviews,
          url: reviewSite.url,
          src: process.env.BASE_S3_PATH + '/' + reviewSite.imagePath
        }

        this.reviewData = reviewData
      } catch (e) {
        this.$ota.general.logError(e)
      }
    },
    ...mapActions('app', {
      getReviews: GET_REVIEWS
    })
  }
}
</script>
